
import React from 'react';
import { Card } from '@/components/ui/card';
import { Profile } from '@/types/profile';
import {
  normalizeHeightDisplay,
  normalizeBodyTypeDisplay,
  normalizeHairColorDisplay,
  normalizeEyeColorDisplay
} from '@/utils/profileDisplayUtils';

interface ProfileAppearanceSectionProps {
  profile: Profile;
}

export const ProfileAppearanceSection: React.FC<ProfileAppearanceSectionProps> = ({ profile }) => {
  return (
    <Card className="bg-white/5 border-white/10 p-4">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-8 h-8 bg-blue-500/20 rounded-full flex items-center justify-center">
          <span className="text-lg">👤</span>
        </div>
        <h3 className="text-white font-medium text-sm">Aparência Física</h3>
      </div>
      <div className="grid grid-cols-2 gap-4 text-xs">
        {profile.height && (
          <div>
            <p className="text-white/60">Altura</p>
            <p className="text-white">{normalizeHeightDisplay(profile.height)}</p>
          </div>
        )}
        {profile.body_type && (
          <div>
            <p className="text-white/60">Tipo Físico</p>
            <p className="text-white">{normalizeBodyTypeDisplay(profile.body_type)}</p>
          </div>
        )}
        {profile.hair_color && (
          <div>
            <p className="text-white/60">Cor do Cabelo</p>
            <p className="text-white">{normalizeHairColorDisplay(profile.hair_color)}</p>
          </div>
        )}
        {profile.eye_color && (
          <div>
            <p className="text-white/60">Cor dos Olhos</p>
            <p className="text-white">{normalizeEyeColorDisplay(profile.eye_color)}</p>
          </div>
        )}
      </div>
    </Card>
  );
};
